import axios from 'axios';
import router from '@/routers/index';
import domMessage from './messageOnce';
const messageOnce = new domMessage();

// 创建axios的实例
const request = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 60000 * 6,
});

// 请求拦截器
request.interceptors.request.use(
    (config) => {
        // 请求token验证设置 排除不需 token 的接口
        let token = sessionStorage.getItem('token');
        let routerList = ['/login/get/captcha', '/kowert/login'];
        if (routerList.includes(config.url)) {
            sessionStorage.removeItem('token');
        } else if (token) {
            config.headers.authorization = token;
        }
        // else {
        //     sessionStorage.clear();
        //     router.replace('/');
        // }

        // 设置请求头
        if (config.url === '/kowert/login') {
            config.headers['Login-Mode'] = 'account-password-login';
        }

        return config;
    },
    (error) => {
        let message = error.response?.data?.msg;
        messageOnce.error({ message });
        Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        if (response.status == 200 && response.headers.authorization) {
            sessionStorage.setItem('token', response.headers.authorization);
        }
        let downloadList = [
            '/download/data/user',
            '/download/data/company',
            '/download/data/routine/inspection',
            '/download/data/inspection/hazard',
        ];
        if (downloadList.includes(response.config.url)) {
            return response;
        }
        return response.data.data;
    },
    (error) => {
        let message =
            error.response.data?.meta?.cause || error.response?.data?.msg;

        if (error.response.data.code == 'B0000') {
            // 认证失败
            localStorage.clear();
            messageOnce.error({ message });
            router.replace('/');
        } else {
            messageOnce.error({ message });
        }
        return Promise.reject(error);
    }
);
export default request;
